import script from "./Activity_CloneTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_CloneTemplate.vue?vue&type=script&setup=true&lang=js"

import "./Activity_CloneTemplate.vue?vue&type=style&index=0&id=d513246c&lang=less&scoped=true"
import "./Activity_CloneTemplate.vue?vue&type=style&index=1&id=d513246c&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d513246c"]])

export default __exports__